export const Division = {
  SNG: 'Scottish Nursing Guild',
  TNS: 'Thornbury Nursing Services',
} as const;

export type DivisionCode = keyof typeof Division;

export type DivisionName = (typeof Division)[DivisionCode];
